import styled from 'styled-components';
import { injectIntl } from 'react-intl';
import {
  DynamicAlertIcon,
  AlertStyleEnum,
} from '#/transit-tracker/components/DynamicAlertIcon';
import DynamicCloseIcon from '#/shared/components/GeneratedIcons/generic/Close';
import { ClearButton } from '#/shared/components/Styled';
import {
  SYSTEM_ALERT_BANNER_HEIGHT,
  GTM_DATA_ATTRIBUTE,
  DESKTOP_MIN_BREAK,
  TABLET_BREAK,
  PHONE_BREAK,
} from '#/shared/constants';
import GTM_HANDLES from '#/shared/gtm-handles';

export const AlertBannerBody = styled.div.attrs(props => ({
  $alertTypeStyle: AlertStyleEnum[props.type],
}))`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${SYSTEM_ALERT_BANNER_HEIGHT};
  background-color: ${props =>
    props.theme[props.$alertTypeStyle.backgroundColor]};
  color: ${props => props.theme[props.$alertTypeStyle.textColor]};
  border-bottom: 2px solid
    ${props => props.theme[props.$alertTypeStyle.borderColor]};
  padding: 0 0.5em;
`;

export const AlertIcon = styled(DynamicAlertIcon).attrs(props => ({
  type: props.type,
}))`
  margin: 0 0.75em 0 0;
  flex-shrink: 1;
  min-width: 1.25em;
  max-width: 2.5em;
  @media (min-width: ${PHONE_BREAK}) {
    margin: 0 1em 0 0;
    max-width: initial;
  }
`;

export const CloseIcon = styled(DynamicCloseIcon).attrs(({ type }) => ({
  $alertTypeStyle: AlertStyleEnum[type],
}))`
  fill: ${props => props.theme[props.$alertTypeStyle.textColor]};
  width: 24px;
  height: 24px;
  @media (min-width: ${PHONE_BREAK}) {
    width: 30px;
    height: 30px;
  }
  @media (min-width: ${TABLET_BREAK}) {
    width: 36px;
    height: 36px;
  }
`;

export const CloseButton = injectIntl(styled(ClearButton).attrs(
  ({ intl, type }) => ({
    $alertTypeStyle: AlertStyleEnum[type],
    title: intl.formatMessage({ id: 'alerts.dismiss-global-alert' }),
  })
)`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  aspect-ratio: 1;
  padding: 0.5em 0.6em 0.5em 0.5em;
  margin: 0;
  @media (any-hover: hover) {
    &:hover {
      background-color: ${props =>
        props.theme[props.$alertTypeStyle.hoverColor]};
    }
    &:hover ${CloseIcon} {
      fill: ${props => props.theme[props.$alertTypeStyle.textHoverColor]};
    }
  }
  @media (min-width: ${TABLET_BREAK}) {
    margin: 0 1em 0 0;
  }
`);

export const IconTitleWrapper = styled.div`
  display: flex;
  flex: 0 1 auto;
  align-items: center;
  @media (any-hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

export const IconTitleViewWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1 1 auto;
  align-items: center;
  justify-content: center;
`;

export const AlertHeaderTitle = styled.div`
  display: flex;
  align-items: center;
  font-size: 1em;
  @media (min-width: ${PHONE_BREAK}) {
    font-size: 1.35em;
  }
  @media (min-width: ${TABLET_BREAK}) {
    font-size: 1.5em;
  }
  @media (min-width: ${DESKTOP_MIN_BREAK}) {
    font-size: 1.7em;
  }
`;

export const AlertButton = injectIntl(styled(ClearButton).attrs(
  ({ intl, type }) => ({
    $alertTypeStyle: AlertStyleEnum[type],
    role: 'link',
    'aria-label': intl.formatMessage({ id: 'alerts.see-all' }),
    [GTM_DATA_ATTRIBUTE]: GTM_HANDLES.shared.systemWideAlertButton,
  })
)`
  font-size: 1em;
  color: ${props => props.theme[props.$alertTypeStyle.textColor]};
  margin-left: 1rem;
  padding: 0.7em;
  margin: 0 0.25em 0 0.5em;
  border-width: 2px;
  border-style: solid;
  border-color: ${props => props.theme[props.$alertTypeStyle.borderColor]};
  border-radius: ${props => props.theme.buttonRadius};
  background-color: ${props =>
    props.theme[props.$alertTypeStyle.backgroundColor]};
  @media (any-hover: hover) {
    &:hover {
      color: ${props => props.theme[props.$alertTypeStyle.textHoverColor]};
      background-color: ${props =>
        props.theme[props.$alertTypeStyle.hoverColor]};
    }
  }
  @media (min-width: ${PHONE_BREAK}) {
    padding: 0.25em 0.75em;
    font-size: 1.4em;
  }
`);
